module.exports = __webpack_public_path__ + "static/img/Chris-Mortimer.d1740bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chris-Mortimer.jpg
// module id = qm3H
// module chunks = 0